import React, { lazy, Suspense } from "react";

import SwiperCore, { Pagination } from "swiper";
import { SwiperSlide } from "swiper/react";
import tw, { styled } from "twin.macro";
import { css } from "@emotion/react";

import { Container } from "@bared/ui";

import { InstagramCard, type InstagramCardProps } from "./InstagramCard";

const Swiper = lazy(
  () => import(/* webpackChunkName: "swiper" */ "@components/Swiper/Swiper"),
);
SwiperCore.use([Pagination]);

const StyledSwiper = styled(Swiper)`
  ${css`
    .swiper-initialized {
      ${tw`pb-mega`}
    }
  `}
`;

export interface InstagramProps {
  posts: ({ _id: string } & InstagramCardProps)[];
}

export function Instagram({ posts }: InstagramProps) {
  if (0 === posts.length) return null;

  return (
    <Container flush={true}>
      <Suspense fallback={<></>}>
        <StyledSwiper
          pagination={{ clickable: true }}
          slidesPerView={2.5}
          preloadImages={false}
          observer={true}
          observeParents={true}
          breakpoints={{
            1024: {
              observer: true,
              observeParents: true,
              slidesPerView: 3.5,
            },
            1281: {
              observer: true,
              observeParents: true,
              slidesPerView: 4.5,
            },
          }}
        >
          {posts.map((post) => (
            <SwiperSlide key={post._id}>
              <InstagramCard {...post} />
            </SwiperSlide>
          ))}
        </StyledSwiper>
      </Suspense>
    </Container>
  );
}
